export default __webpack_public_path__ + "static/media/example_1.23b6c148.svg";